// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Sayfa yolu (pathname) her değiştiğinde pencereyi en yukarı kaydır
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}